(function () {
  'use strict';

  angular.module('app.youtubePostOverview')
    .factory('youtubePostOverviewService', ['$q', '$http', '$rootScope',
      function ($q, $http, $rootScope) {

        var service = {};

        function checkResponse(data) {
          return data;
        }

        function getMessage(data) {
          if (data) {
            return data.message;
          }
          return false;
        }

        function handleRequest(url) {
          var deferred = $q.defer(), result = 'requestFail';
          $http.get(url)
            .success(function (data) {
              var dataRes = angular.fromJson(data);

              if (checkResponse(dataRes)) {
                deferred.resolve(dataRes);
              } else {
                deferred.reject(getMessage(dataRes) || result);
              }
            })
            .error(function () {
              deferred.reject(result);
            });

          return deferred.promise;
        }

        function getYoutubePostOverviewLineChart(url_hash, relativepath, published_date) {
          var url_getBlogpostOverviewLineChart = $rootScope.apiUrl + 'blogpost/getBlogpostOverviewLineChart?url_hash=' + url_hash + '&relativepath=' + relativepath + '&date=' + published_date;
          return handleRequest(url_getBlogpostOverviewLineChart);
        }

        function getYoutubePostOverviewPieChart(url, relativepath) {
          var url_getBlogpostOverviewPieChart = $rootScope.apiUrl + 'blogpost/getBlogpostOverviewPieChart?full_url=' + url + '&relativepath=' + relativepath;
          return handleRequest(url_getBlogpostOverviewPieChart);
        }


        function getTop5PostsInSameInfluencer(influencer_id, url_hash) {
          var url_getTop5PostsInSameInfluencer = $rootScope.apiUrl + 'blogpost/getTop5PostsInSameInfluencer?influencer_id=' + influencer_id + '&url_hash=' + url_hash;
        }

        function getTop5PostsInSameTopic(influencer_id, url_hash, topic_id) {
          var url_getTop5PostsInAllInfluencer = $rootScope.apiUrl + 'blogpost/getTop5PostsInSameTopic?influencer_id=' + influencer_id + '&url_hash=' + url_hash + '&topic_id=' + topic_id;
        }


        function getRelatedPosts(influencer_id, topic_id) {
          var url_getRelatedPosts = $rootScope.apiUrl + 'blogpost/getRelatedPosts?influencer_id=' + influencer_id + '&topic_id=' + topic_id;
        }

        service.getYoutubePostOverviewLineChart = getYoutubePostOverviewLineChart;

        service.getYoutubePostOverviewPieChart = getYoutubePostOverviewPieChart;

        service.getTop5PostsInSameInfluencer = getTop5PostsInSameInfluencer;

        service.getTop5PostsInSameTopic = getTop5PostsInSameTopic;

        service.getRelatedPosts = getRelatedPosts;

        return service;
      }]);

  

})();
